import { useT } from '../../i18n';

interface Props {
  minutesLeft: number;
  onStayLoggedIn: () => void;
}

/**
 * Non-intrusive banner shown at the top of the page when the session
 * is about to expire due to inactivity.
 */
export function InactivityWarningBanner({ minutesLeft, onStayLoggedIn }: Props) {
  const { t } = useT();

  return (
    <div
      role="alert"
      className="fixed top-0 left-0 right-0 z-50 bg-amber-600 text-white px-4 py-3 flex items-center justify-center gap-4 text-sm shadow-lg animate-in slide-in-from-top duration-300"
    >
      <span>{t('session.warning', minutesLeft)}</span>
      <button
        onClick={onStayLoggedIn}
        className="shrink-0 px-4 py-1.5 rounded-lg bg-white text-amber-700 font-semibold text-sm hover:bg-amber-50 transition-colors focus:outline-none focus:ring-2 focus:ring-white/50"
      >
        {t('session.stay')}
      </button>
    </div>
  );
}
